export const SAVE_STATUS = {
  SAVED: 'saved',
  SAVING: 'saving',
  ERROR: 'error',
};
